import authInterceptor from "../AuthInterceptor";

export const DashboardAPI = {
    getTableData: (config) =>
        authInterceptor.get(`ranking-api/dashboard_api/`, config)
            .then((response) => response.data)
            .catch((error) => error.response),
}